<template>
    <div>
        <span v-if="!arquivado">Cancelado</span>
        <v-menu offset-y transition="slide-x-transition" bottom left
                :close-on-content-click=false content-class="az-menu-lista">
            <template v-slot:activator="{ on }">
                <v-btn small icon v-on="on">
                    <v-icon color="white"> mdi-chevron-down</v-icon>
                </v-btn>
            </template>
            <v-card class="motivo-cancelamento-card">
                <v-card-text class="motivo-cancelamento-text">
                    <v-layout wrap>
                        <v-flex xs12 sm12 md12>
                            <az-text-view
                                label="Justificativa"
                                :text="minuta.motivoCancelamento"/>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                            <az-text-view
                                label="Data do Cancelamento"
                                :text="minuta.dataCancelamento | azDate "/>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                            <az-text-view
                                label="Usuário"
                                :text="minuta.autorCancelamento ? minuta.autorCancelamento : '-'"/>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-menu>
    </div>
</template>
<script>

export default {
    name: 'VisualizarCancelamento',
    props: {
        minuta: {
            required: true
        },
        arquivado: {
            type: Boolean,
            default: false,
            required: false
        }
    },
}
</script>

<style lang="stylus">
.motivo-cancelamento-card
    width 330px

    .motivo-cancelamento-text
        .az-text
            p
                text-overflow ellipsis
                width 100%
                overflow hidden
                white-space nowrap
</style>
